import http from "../../http";
import { cacheLeftMenuLinks } from "../../../js/menu";

/**
 * 基础公共接口
 * 菜单、城市、标签、行业、领域、管理员、验证码、短链接等
 */
export default {
  // 左侧导航栏
  leftMenuList: (params) => {
    return http.get("opservice/tenant/security/current/menu/left", params)
      .then((data) => {
        // 菜单数据全局落库，供列表页「详情返回保持分页」判断详情页用
        if (data && data.code == 0 && Array.isArray(data.data)) {
          cacheLeftMenuLinks(data.data);
        }
        return data;
      });
  },
  // 顶部导航栏
  getmenu: (params) => {
    return http.get("opservice/tenant/security/current/menu/top", params);
  },
  // 获取城市数据（国内）
  homeCityList: (params) => {
    return http.get("opservice/opbasedocarea/allcity.json", params);
  },
  // 获取城市数据（含海外）
  abroadCityList: (params) => {
    return http.get("opservice/opbasedocarea/allcityAbroad.json", params);
  },
  // 获取所有的系统标签
  tagList: (data) => {
    return http.post("opservice/opbasedoclabel/list", data);
  },
  // 获取所有行业
  industryList: (params) => {
    return http.get("content-service/sys_industry/list", params);
  },
  // 获取所有领域
  fieldList: (params) => {
    return http.get("content-service/sys_field/list", params);
  },
  // 获取产品树（公共选择器）
  productList: (params) => {
    return http.get("cmsservice/productSort/op/tree", params);
  },
  // 获取协作管理员
  getAllAdmin: (data) => {
    return http.post("opservice/enterpriseadmin/paged_all", data);
  },
  // 获取在线人数
  getUserOnline: (params) => {
    return http.post("searchservice/official/website/count/user/online", params);
  },
  // 生成短链接
  generateShortUrl: (params) => {
    return http.post("y/generatecode", params);
  },
  // 获取验证码
  getCode: (params) => {
    return http.get("opservice/regist/code", params);
  },
  // 验证码是否正确
  isTrueCode: (params) => {
    return http.get("opservice/regist/iscode", params);
  },
};
